import _ from "lodash";

export default function toFormatCase(text:string, type: string): string|undefined {
    if (type === "lower") {
        return _.toLower(text);
    } else if (type === "upper") {
        return _.toUpper(text);
    }
}